export const getSignedInstance = async (httpClient, metaSiteId) => {
  const response = await httpClient.get(`/account/sites/api/sites/${metaSiteId}/signedInstance`);
  return response.data.instance;
};
//# sourceMappingURL=getSignedInstance.js.map